import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './Components/semantics/Header/Header';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Reg from './Pages/Reg/Reg';
import User from './Pages/User/User';
import Auth from './Pages/Auth/Auth';
import { Soglasie } from './Pages/Soglasie/Soglasie';
import Footer from './Components/semantics/Header/Footer/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './Store/store';
import { init, setIsAuth, setStep, setUser } from './Store/userSlice';
import Education from './Pages/Education/Education';
import Test from './Pages/Test/Test';
import TestResult from './Pages/TestResult/TestResult';
import Account from './Pages/Account/Account';
import Edit from './Pages/Edit/Edit';
import RegResult from './Pages/Reg/RegResult';
import FullSpaseLoader from './Components/UI/Loader/FullSpaseLoader';
import UserApi from './API/UserAPI';

function App() {

  const isAuth = useSelector( (state:RootState)=>state.user.isAuth)
  const lessons = useSelector((state:RootState)=>state.user.lessons)
  const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
  const dispatch = useDispatch()

  const [isLoader, setIsLoader] = useState(true)

  const appInit= async()=>{

    if(!localStorage.getItem("token")){
      setIsLoader(false)
      return;
    }

    const user = await UserApi.get()

    if( user?.user===null  || user?.lesson_id===null){
        window.location.reload()
        return;
    }

    dispatch(setUser(user.user))
    dispatch(setStep(user.lesson_id))
    dispatch(setIsAuth(true))

    setIsLoader(false)
  }

  useEffect(()=>{
     appInit()
  },[])

  

  return (
    <div className="App">
      <FullSpaseLoader isLoader={isLoader}/>
      {
        !isLoader?
        <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Auth />}/>
          <Route path='*' element={<Auth />}/>
          
          {
            isAuth?<>
            <Route path='/user' element={<User />}/>
            <Route path='/edit' element={<Edit />}/>
            <Route path='/education' element={<Education />}/>
            <Route path='/test' element={maxActiveLessonId>=lessons.length?<TestResult />:<Test />}/>
            <Route path='/testresult' element={<TestResult />}/>
            <Route path='/accaunt' element={<Account />}/>
            </>:<></>
          }
          
        
          <Route path='/reg' element={<Reg />}/>
          <Route path='/regresult' element={<RegResult />}/>
          <Route path='/auth' element={<Auth />}/>
            
          
          <Route path='/soglasie' element={<Soglasie/>}/>
          
        </Routes>
        <Footer/>
      </BrowserRouter>
      :
      <></>
      
      }
      
    </div>
  );
}

export default App;
